import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getTaskStatus',
})
export class GetTaskStatusPipe implements PipeTransform {
  transform(status: any): any {
    switch (status) {
      case 'PLANNED':
        return 'Planned';
      case 'IN_PROGRESS':
        return 'In Progress ';
      case 'DONE':
        return 'Done';
      case 'WAITING':
        return 'Waiting';
      case 'ON_HOLD':
        return 'On Hold';
      case 'CANCELED':
        return 'Canceled';
    }
  }
}
